import React from 'react'
import Favorites from '../components/Favorites'

function MyFavorites() {
  return (
    <div>
      <Favorites />
    </div>
  )
}

export default MyFavorites